const playerPhotos = [
  {
    fullName: 'Andreas Johnsson',
    nhlPlayerId: 8477341,
    nhlpaPhotoId: 54480,
  },
  {
    fullName: 'Ilya Mikheyev',
    nhlPlayerId: 8481624,
    nhlpaPhotoId: 56764,
  },
  {
    fullName: 'Jason Spezza',
    nhlPlayerId: 8469455,
    nhlpaPhotoId: 24048,
  },
  {
    fullName: 'Jake Muzzin',
    nhlPlayerId: 8474162,
    nhlpaPhotoId: 30779,
  },
  {
    fullName: 'Kyle Clifford',
    nhlPlayerId: 8475160,
    nhlpaPhotoId: 32052,
  },
  {
    fullName: 'John Tavares',
    nhlPlayerId: 8475166,
    nhlpaPhotoId: 30200,
  },
  {
    fullName: 'Tyson Barrie',
    nhlPlayerId: 8475197,
    nhlpaPhotoId: 32306,
  },
  {
    fullName: 'Martin Marincin',
    nhlPlayerId: 8475716,
    nhlpaPhotoId: 32869,
  },
  {
    fullName: 'Justin Holl',
    nhlPlayerId: 8475718,
    nhlpaPhotoId: 32878,
  },
  {
    fullName: 'Zach Hyman',
    nhlPlayerId: 8475786,
    nhlpaPhotoId: 32952,
  },
  {
    fullName: 'Jack Campbell',
    nhlPlayerId: 8475789,
    nhlpaPhotoId: 32810,
  },
  {
    fullName: 'Frederik Andersen',
    nhlPlayerId: 8475883,
    nhlpaPhotoId: 32776,
  },
  {
    fullName: 'Morgan Rielly',
    nhlPlayerId: 8476853,
    nhlpaPhotoId: 33938,
  },
  {
    fullName: 'Cody Ceci',
    nhlPlayerId: 8476879,
    nhlpaPhotoId: 33939,
  },
  {
    fullName: 'Alexander Kerfoot',
    nhlPlayerId: 8477021,
    nhlpaPhotoId: 34174,
  },
  {
    fullName: 'Frederik Gauthier',
    nhlPlayerId: 8477512,
    nhlpaPhotoId: 54341,
  },
  {
    fullName: 'William Nylander',
    nhlPlayerId: 8477939,
    nhlpaPhotoId: 54571,
  },
  {
    fullName: 'Kasperi Kapanen',
    nhlPlayerId: 8477953,
    nhlpaPhotoId: 54578,
  },
  {
    fullName: 'Pierre Engvall',
    nhlPlayerId: 8478115,
    nhlpaPhotoId: 54940,
  },
  {
    fullName: 'Travis Dermott',
    nhlPlayerId: 8478408,
    nhlpaPhotoId: 55213,
  },
  {
    fullName: 'Mitchell Marner',
    nhlPlayerId: 8478483,
    nhlpaPhotoId: 54995,
  },
  {
    fullName: 'Denis Malgin',
    nhlPlayerId: 8478843,
    nhlpaPhotoId: 55273,
  },
  {
    fullName: 'Auston Matthews',
    nhlPlayerId: 8479318,
    nhlpaPhotoId: 55584,
  },
  {
    fullName: 'Calle Rosen',
    nhlPlayerId: 8480157,
    nhlpaPhotoId: 56047,
  },
  {
    fullName: 'Rasmus Sandin',
    nhlPlayerId: 8480873,
    nhlpaPhotoId: 56486,
  },
  {
    fullName: 'Victor Mete',
    nhlPlayerId: 8479376,
    nhlpaPhotoId: 55726,
  },
  {
    fullName: 'Jake Evans',
    nhlPlayerId: 8478133,
    nhlpaPhotoId: 0,
  },
  {
    fullName: 'Shea Weber',
    nhlPlayerId: 8470642,
    nhlpaPhotoId: 27048,
  },
  {
    fullName: 'Carey Price',
    nhlPlayerId: 8471679,
    nhlpaPhotoId: 29074,
  },
  {
    fullName: 'Joe Schmoe',
    nhlPlayerId: 1111111,
    nhlpaPhotoId: 11111,
  },
  {
    fullName: 'Jeff Petry',
    nhlPlayerId: 8473507,
    nhlpaPhotoId: 29849,
  },
  {
    fullName: 'Karl Alzner',
    nhlPlayerId: 8473991,
    nhlpaPhotoId: 30625,
  },
  {
    fullName: 'Paul Byron',
    nhlPlayerId: 8474038,
    nhlpaPhotoId: 30811,
  },
  {
    fullName: 'Dale Weise',
    nhlPlayerId: 8474668,
    nhlpaPhotoId: 30329,
  },
  {
    fullName: 'Tomas Tatar',
    nhlPlayerId: 8475193,
    nhlpaPhotoId: 31171,
  },
  {
    fullName: 'Ben Chiarot',
    nhlPlayerId: 8475279,
    nhlpaPhotoId: 31947,
  },
  {
    fullName: 'Jordan Weal',
    nhlPlayerId: 8475738,
    nhlpaPhotoId: 32911,
  },
  {
    fullName: 'Brendan Gallagher',
    nhlPlayerId: 8475848,
    nhlpaPhotoId: 32970,
  },
  {
    fullName: 'Xavier Ouellet',
    nhlPlayerId: 8476443,
    nhlpaPhotoId: 33494,
  },
  {
    fullName: 'Joel Armia',
    nhlPlayerId: 8476469,
    nhlpaPhotoId: 33427,
  },
  {
    fullName: 'Phillip Danault',
    nhlPlayerId: 8476479,
    nhlpaPhotoId: 33437,
  },
  {
    fullName: 'Charles Hudon',
    nhlPlayerId: 8476948,
    nhlpaPhotoId: 33177,
  },
  {
    fullName: 'Brett Kulak',
    nhlPlayerId: 8476967,
    nhlpaPhotoId: 34115,
  },
  {
    fullName: 'Artturi Lehkonen',
    nhlPlayerId: 8477476,
    nhlpaPhotoId: 54368,
  },
  {
    fullName: 'Jonathan Drouin',
    nhlPlayerId: 8477494,
    nhlpaPhotoId: 54329,
  },
  {
    fullName: 'Max Domi',
    nhlPlayerId: 8477503,
    nhlpaPhotoId: 54337,
  },
  {
    fullName: 'Christian Folin',
    nhlPlayerId: 8477850,
    nhlpaPhotoId: 54690,
  },
  {
    fullName: 'Charlie Lindgren',
    nhlPlayerId: 8479292,
    nhlpaPhotoId: 55511,
  },
  {
    fullName: 'Nick Suzuki',
    nhlPlayerId: 8480018,
    nhlpaPhotoId: 56086,
  },
  {
    fullName: 'Wayne Simmonds',
    nhlPlayerId: 8474190,
    nhlpaPhotoId: 30517,
  },
  {
    fullName: 'Zach Bogosian',
    nhlPlayerId: 8474567,
    nhlpaPhotoId: 31474,
  },
  {
    fullName: 'TJ Brodie',
    nhlPlayerId: 8474673,
    nhlpaPhotoId: 31557,
  },
  {
    fullName: 'Travis Boyd',
    nhlPlayerId: 8476329,
    nhlpaPhotoId: 33594,
  },
  {
    fullName: 'Jimmy Vesey',
    nhlPlayerId: 8476918,
    nhlpaPhotoId: 34035,
  },
  {
    fullName: 'Nic Petan',
    nhlPlayerId: 8477464,
    nhlpaPhotoId: 54358,
  },
  {
    fullName: 'Joey Anderson',
    nhlPlayerId: 8479315,
    nhlpaPhotoId: 55708,
  },
  {
    fullName: 'Joseph Woll',
    nhlPlayerId: 8479361,
    nhlpaPhotoId: 55704,
  },
  {
    fullName: 'Nicholas Robertson',
    nhlPlayerId: 8481582,
    nhlpaPhotoId: 56990,
  },
  {
    fullName: 'Aaron Dell',
    nhlPlayerId: 8477180,
    nhlpaPhotoId: 55092,
  },
  {
    fullName: 'Joe Thornton',
    nhlPlayerId: 8466138,
    nhlpaPhotoId: 6403,
  },
  {
    fullName: 'Corey Perry',
    nhlPlayerId: 8470621,
    nhlpaPhotoId: 27038,
  },
  {
    fullName: 'Jake Allen',
    nhlPlayerId: 8474596,
    nhlpaPhotoId: 31373,
  },
  {
    fullName: 'Tyler Toffoli',
    nhlPlayerId: 8475726,
    nhlpaPhotoId: 32870,
  },
  {
    fullName: 'Joel Edmundson',
    nhlPlayerId: 8476441,
    nhlpaPhotoId: 33492,
  },
  {
    fullName: 'Josh Anderson',
    nhlPlayerId: 8476981,
    nhlpaPhotoId: 34107,
  },
  {
    fullName: 'Jake Evans',
    nhlPlayerId: 8478133,
    nhlpaPhotoId: 54957,
  },
  {
    fullName: 'Jesperi Kotkaniemi',
    nhlPlayerId: 8480829,
    nhlpaPhotoId: 56059,
  },
  {
    fullName: 'Petr Mrazek',
    nhlPlayerId: 8475852,
    nhlpaPhotoId: 31230,
  },
  {
    fullName: 'Ondrej Kase',
    nhlPlayerId: 8478131,
    nhlpaPhotoId: 54955,
  },
  {
    fullName: 'Michael Hutchinson',
    nhlPlayerId: 8474636,
    nhlpaPhotoId: 31529,
  },
  {
    fullName: 'Nick Ritchie',
    nhlPlayerId: 8477941,
    nhlpaPhotoId: 54783,
  },
  {
    fullName: 'Michael Bunting',
    nhlPlayerId: 8478047,
    nhlpaPhotoId: 54876,
  },
  {
    fullName: 'Timothy Liljegren',
    nhlPlayerId: 8480043,
    nhlpaPhotoId: 56107,
  },
  {
    fullName: 'David Kampf',
    nhlPlayerId: 8480144,
    nhlpaPhotoId: 56022,
  },
  {
    fullName: 'Alex Biega',
    nhlPlayerId: 8473415,
    nhlpaPhotoId: 29902,
  },
];

export default playerPhotos;